import { render, staticRenderFns } from "./IndicadorInvestigadoresArea.vue?vue&type=template&id=cc1d5830&"
import script from "./IndicadorInvestigadoresArea.vue?vue&type=script&lang=js&"
export * from "./IndicadorInvestigadoresArea.vue?vue&type=script&lang=js&"
import style0 from "./IndicadorInvestigadoresArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports